import { STEPS, NAME_AGG_MAPPING, PHOTO_AGG_MAPPING } from './ConfigureAggregationsV2.const';

// GLOBALS
const API_HOST = process.env.REACT_APP_ADMIN_API_HOST;

class Topic {
  constructor(topic /* string */, shared /* object */) {
    this.topic = topic;
    this.shared = shared;

    // genericGet = async (url, token, callback, ignoreCredentials)
    window.genericGet(`${API_HOST}/admin/v0/topics/questions/${topic}`, null, (e, existingQuestions) => {
      if (e) {
        throw e;
      }
      this.existingQuestions = existingQuestions;
    });
  }

  getConfig() {
    return { [this.topic]: this.completedFormQuestions };
  }

  isComplete() {
    return this.completedFormQuestions && this.incompleteFormQuestions.length === 0;
  }

  // onComplete(
  //   reduce(nameKeys),
  //   nameOverride,
  //   reduce(photoKeys),
  //   selections.map((d) => reduce(d))
  // );
  onSelectQuestions(names, nameOverride, photos, selections, setState) {
    if (!this.existingQuestions) {
      return setTimeout(() => {
        this.onSelectQuestions(...arguments);
      }, 500);
    }

    this.incompleteFormQuestions = selections;
    this.completedFormQuestions = [];

    const newTopic = this.existingQuestions.length === 0;

    if (!nameOverride) {
      this.completedFormQuestions.push({
        formQuestion: names,
        newAggMapping: newTopic ? NAME_AGG_MAPPING : undefined,
        existingQuestion: !newTopic ? { display_key: 'name' } : undefined
      });
    } else {
      this.completedFormQuestions.push({
        formQuestion: {
          input_type: 'STATIC_FICTIONAL'
        },
        nameOverride
      });
    }

    this.completedFormQuestions.push({
      formQuestion: photos,
      newAggMapping: newTopic ? PHOTO_AGG_MAPPING : undefined,
      existingQuestion: !newTopic ? { display_key: 'photo' } : undefined
    });

    let allNames = [];
    if (this.completedFormQuestions.length > 0) {
      allNames = allNames.concat(this.completedFormQuestions.flatMap((d) => d.formQuestion.names));
    }
    if (this.incompleteFormQuestions.length > 0) {
      allNames = allNames.concat(this.incompleteFormQuestions.flatMap((d) => d.names));
    }
    this.shared.selectedNames = Array.from(new Set(allNames.filter((d) => !!d)));

    if (this.incompleteFormQuestions.length === 0) {
      // move to next Topic, or Review screens
      setState();
    } else {
      if (!this.shared.musts && this.incompleteFormQuestions.map((d) => d.input_type).includes('SELECT_ONE')) {
        setState({
          step: STEPS.DIVIDE_FORM,
          stepProps: {
            formQuestions: this.incompleteFormQuestions,
            selectedForm: this.shared.form,
            topic: this.topic,
            selectedTopics: this.shared.topics.map((d) => d.topic),
            onComplete: this.onDivideForm.bind(this)
          }
        });
      } else {
        this.flattenOpts();
        this.nextMapOrAgg(setState);
      }
    }
  }
  onMapQuestion(formQuestion, existingQuestion, setState) {
    // skipped, was only used to divide form data
    if (existingQuestion === false) {
      this.completedFormQuestions.push({
        formQuestion,
        existingQuestion: false
      });
      if (this.incompleteFormQuestions.length === 0) {
        setState();
      } else {
        this.nextMapOrAgg(setState);
      }
    } else if (existingQuestion) {
      if (['TEXT', 'PHOTO', 'NUMBER', 'SCREENSHOT'].includes(formQuestion.input_type)) {
        this.completedFormQuestions.push({
          formQuestion,
          existingQuestion
          // answerMapping
        });

        if (this.incompleteFormQuestions.length > 0) {
          this.nextMapOrAgg(setState);
        } else {
          setState();
        }
      } else {
        // reduce
        setState({
          step: STEPS.REDUCE_ANSWERS,
          stepProps: {
            formQuestion,
            existingQuestion,
            onComplete: this.onReduceAnswers.bind(this)
          }
        });
      }
    } else {
      // create agg.
      setState({
        step: STEPS.CREATE_NEW_AGG,
        stepProps: {
          usedDisplayKeys: this.getUsedDisplayKeys(),
          formQuestion: formQuestion,
          topic: this.topic,
          selectedForm: this.shared.form,
          onComplete: this.onCreateAgg.bind(this)
        }
      });
    }
  }
  getUsedDisplayKeys() {
    return this.completedFormQuestions
      .map((d) => {
        if (d.newAggMapping) {
          return d.newAggMapping.name;
        } else if (d.existingQuestion) {
          return d.existingQuestion.display_key;
        } else if (d.nameOverride) {
          return 'name';
        } else {
          return null;
        }
      })
      .filter((d) => !!d);
  }
  onReduceAnswers(formQuestion, setState) {
    this.completedFormQuestions.push(formQuestion);

    if (this.incompleteFormQuestions.length > 0) {
      this.nextMapOrAgg(setState);
    } else {
      setState();
    }
  }
  nextMapOrAgg(setState) {
    if (this.existingQuestions.length > 0) {
      // map
      setState({
        step: STEPS.MAP_QUESTIONS,
        stepProps: {
          topic: this.topic,
          formQuestion: this.incompleteFormQuestions.pop(),
          existingQuestions: this.existingQuestions,
          musts: this.shared.musts,
          onComplete: this.onMapQuestion.bind(this)
        }
      });
    } else {
      // create agg
      setState({
        step: STEPS.CREATE_NEW_AGG,
        stepProps: {
          usedDisplayKeys: this.getUsedDisplayKeys(),
          formQuestion: this.incompleteFormQuestions.pop(),
          topic: this.topic,
          selectedForm: this.shared.form,
          onComplete: this.onCreateAgg.bind(this)
        }
      });
    }
  }
  onCreateAgg(formQuestion, setState) {
    if (formQuestion) {
      this.completedFormQuestions.push(formQuestion);
    }

    if (this.incompleteFormQuestions.length > 0) {
      this.nextMapOrAgg(setState);
    } else {
      // move to next Topic, or Review screens
      setState();
    }
  }
  flattenOpts() {
    // patch up the opts object within incompleteFormQuestions
    for (const fq of this.incompleteFormQuestions) {
      fq.opts = fq.opts.reduce((a, b) => a.concat(b), []);

      const tmpDict = {};
      for (const opt of fq.opts) {
        tmpDict[opt.value] = opt.label;
      }

      fq.opts = Object.keys(tmpDict).map((d) => ({
        value: d,
        label: tmpDict[d]
      }));
    }
  }
  onDivideForm(musts, setState) {
    this.shared.musts = musts;
    this.flattenOpts();
    this.nextMapOrAgg(setState);
  }
  nextState() {
    if (!this.incompleteFormQuestions) {
      return {
        step: STEPS.SELECT_QUESTIONS,
        stepProps: {
          selectedNames: this.shared.selectedNames,
          onComplete: this.onSelectQuestions.bind(this),
          form: this.shared.form,
          topic: this.topic
        }
      };
    }
  }
}

export default Topic;
